import HomepageMp3 from '../components/pages/Homepage/audio/homepage.mp3';
import HomepageAif from '../components/pages/Homepage/audio/homepage.aif';

import BeneficiaryMp3 from '../components/pages/Beneficiary/audio/beneficiary.mp3';
import BeneficiaryAif from '../components/pages/Beneficiary/audio/beneficiary.aif';

import ClaimProcessMp3 from '../components/pages/ClaimProcess/audio/claim-process.mp3';
import ClaimProcessAif from '../components/pages/ClaimProcess/audio/claim-process.aif';

import DeathCertificateMp3 from '../components/pages/DeathCertificate/audio/death-certificate.mp3';
import DeathCertificateAif from '../components/pages/DeathCertificate/audio/death-certificate.aif';

import SubmitDocumentationMp3 from '../components/pages/SubmitDocumentation/audio/submit-documentation.mp3';
import SubmitDocumentationAif from '../components/pages/SubmitDocumentation/audio/submit-documentation.aif';

import InsuranceBenefitsMp3 from '../components/pages/InsuranceBenefits/audio/insurance-benefits.mp3';
import InsuranceBenefitsAif from '../components/pages/InsuranceBenefits/audio/insurance-benefits.aif';
import InsuranceBenefitsNonTcaMp3 from '../components/pages/InsuranceBenefits/audio/insurance-benefits-non-tca.mp3';
import InsuranceBenefitsNonTcaAif from '../components/pages/InsuranceBenefits/audio/insurance-benefits-non-tca.aif';

import QuestionsMp3 from '../components/pages/Questions/audio/questions.mp3';
import QuestionsAif from '../components/pages/Questions/audio/questions.aif';

export const Homepage = { mp3: HomepageMp3, aif: HomepageAif };
export const Beneficiary = { mp3: BeneficiaryMp3, aif: BeneficiaryAif };
export const ClaimProcess = { mp3: ClaimProcessMp3, aif: ClaimProcessAif };
export const DeathCertificate = { mp3: DeathCertificateMp3, aif: DeathCertificateAif };
export const SubmitDocumentation = { mp3: SubmitDocumentationMp3, aif: SubmitDocumentationAif };
// This one is a bit non-standard. The audio choice is determined by an env variable that gets env-ified during the build.
export const InsuranceBenefits = {
    mp3: process.env.REACT_APP_NON_TCA ? InsuranceBenefitsNonTcaMp3 : InsuranceBenefitsMp3,
    aif: process.env.REACT_APP_NON_TCA ? InsuranceBenefitsNonTcaAif : InsuranceBenefitsAif,
};
export const Questions = { mp3: QuestionsMp3, aif: QuestionsAif };

export default {
    /**
     * The names of these keys purposefully match with their corresponding
     * React components. This way, it hopefully is a bit more clear when
     * we dispatch an action from a component (e.g., `this.props.setAudioToPlay('Homepage')`),
     * The string we're passing in seems derived from _somewhere_.
     * 
     * I'd prefer to have a constant we use here, and this object would use those
     * same constants as their keys, but ¯\_(ツ)_/¯
     */
    Homepage,
    Beneficiary,
    ClaimProcess,
    DeathCertificate,
    SubmitDocumentation,
    InsuranceBenefits,
    Questions,
};
